import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { SimpleTitle } from "../styles";
import {
    ARCHIVE_TEAM_STATUS,
    PUBLISHED_TEAM_STATUS,
    REJECTED_TEAM_STATUS,
    UNDER_APPROVAL_TEAM_STATUS,
} from "shared/helpers/teamsStatus";

const DEFAULT_SUPPORT_EMAIL = "support@mediiia.com";

const getActionInfo = (item: any) => {
    const action = item?.actions?.[0] || {};
    const info = action?.teamStatusChangeInfo || {};

    return {
        action,
        info,
    };
};

const getTeamName = (action: any, info: any) => {
    if (typeof info?.teamName === "string" && info.teamName.trim()) return info.teamName;
    if (typeof action?.teamName === "string" && action.teamName.trim()) return action.teamName;
    if (typeof info?.name === "string" && info.name.trim()) return info.name;
    if (typeof action?.entityName === "string" && action.entityName.trim()) return action.entityName;
    return "";
};

const getStatus = (action: any, info: any) => {
    const rawStatus = info?.status ?? info?.newStatus ?? action?.status ?? action?.newStatus;
    const normalized = Number(rawStatus);
    if (Number.isNaN(normalized)) return undefined;
    return normalized;
};

const getSupportEmail = (action: any, info: any) => {
    if (typeof info?.supportEmail === "string" && info.supportEmail.trim()) return info.supportEmail;
    if (typeof action?.supportEmail === "string" && action.supportEmail.trim()) return action.supportEmail;
    if (typeof process.env.REACT_APP_SUPPORT_EMAIL === "string" && process.env.REACT_APP_SUPPORT_EMAIL.trim()) {
        return process.env.REACT_APP_SUPPORT_EMAIL;
    }
    return DEFAULT_SUPPORT_EMAIL;
};

const getFallbackTitle = (item: any, action: any) => {
    if (typeof action?.title === "string" && action.title.trim()) return action.title;
    if (typeof item?.notificationText === "string" && item.notificationText.trim()) return item.notificationText;
    return "";
};

export const getTeamStatusChangeTitle = (item: any, t: any) => {
    const { action, info } = getActionInfo(item);
    const teamName = getTeamName(action, info);
    const status = getStatus(action, info);
    const supportEmail = getSupportEmail(action, info);
    const fallbackTitle = getFallbackTitle(item, action);
    const hasTeamName = Boolean(teamName);

    if (status === UNDER_APPROVAL_TEAM_STATUS && hasTeamName) {
        return t("notifications.team_status_change_under_approval", { teamName });
    }

    if (status === PUBLISHED_TEAM_STATUS && hasTeamName) {
        return t("notifications.team_status_change_active", { teamName });
    }

    if (status === REJECTED_TEAM_STATUS && hasTeamName) {
        return t("notifications.team_status_change_rejected", { teamName, supportEmail });
    }

    if (status === ARCHIVE_TEAM_STATUS && hasTeamName) {
        return t("notifications.team_status_change_archive", { teamName, supportEmail });
    }

    return fallbackTitle;
};

export const NotificationTeamStatusChange: FC<{ item: any }> = ({ item }) => {
    const { t } = useTranslation();
    const title = useMemo(() => getTeamStatusChangeTitle(item, t), [item, t]);

    if (!title) return null;

    return (
        <SimpleTitle>
            {title}
        </SimpleTitle>
    );
};
import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { SimpleTitle } from "../styles";
import {
    ARCHIVE_TEAM_STATUS,
    PUBLISHED_TEAM_STATUS,
    REJECTED_TEAM_STATUS,
    UNDER_APPROVAL_TEAM_STATUS,
} from "shared/helpers/teamsStatus";

const DEFAULT_SUPPORT_EMAIL = "support@mediiia.com";

const getActionInfo = (item: any) => {
    const action = item?.actions?.[0] || {};
    const info = action?.teamStatusChangeInfo || {};

    return {
        action,
        info,
    };
};

const getTeamName = (action: any, info: any) => {
    if (typeof info?.teamName === "string" && info.teamName.trim()) return info.teamName;
    if (typeof action?.teamName === "string" && action.teamName.trim()) return action.teamName;
    if (typeof info?.name === "string" && info.name.trim()) return info.name;
    if (typeof action?.entityName === "string" && action.entityName.trim()) return action.entityName;
    return "";
};

const getStatus = (action: any, info: any) => {
    const rawStatus = info?.status ?? info?.newStatus ?? action?.status ?? action?.newStatus;
    const normalized = Number(rawStatus);
    if (Number.isNaN(normalized)) return undefined;
    return normalized;
};

const getSupportEmail = (action: any, info: any) => {
    if (typeof info?.supportEmail === "string" && info.supportEmail.trim()) return info.supportEmail;
    if (typeof action?.supportEmail === "string" && action.supportEmail.trim()) return action.supportEmail;
    if (typeof process.env.REACT_APP_SUPPORT_EMAIL === "string" && process.env.REACT_APP_SUPPORT_EMAIL.trim()) {
        return process.env.REACT_APP_SUPPORT_EMAIL;
    }
    return DEFAULT_SUPPORT_EMAIL;
};

const getFallbackTitle = (item: any, action: any) => {
    if (typeof action?.title === "string" && action.title.trim()) return action.title;
    if (typeof item?.notificationText === "string" && item.notificationText.trim()) return item.notificationText;
    return "";
};

export const getTeamStatusChangeTitle = (item: any, t: any) => {
    const { action, info } = getActionInfo(item);
    const teamName = getTeamName(action, info);
    const status = getStatus(action, info);
    const supportEmail = getSupportEmail(action, info);
    const fallbackTitle = getFallbackTitle(item, action);
    const hasTeamName = Boolean(teamName);

    if (status === UNDER_APPROVAL_TEAM_STATUS && hasTeamName) {
        return t("notifications.team_status_change_under_approval", { teamName });
    }

    if (status === PUBLISHED_TEAM_STATUS && hasTeamName) {
        return t("notifications.team_status_change_active", { teamName });
    }

    if (status === REJECTED_TEAM_STATUS && hasTeamName) {
        return t("notifications.team_status_change_rejected", { teamName, supportEmail });
    }

    if (status === ARCHIVE_TEAM_STATUS && hasTeamName) {
        return t("notifications.team_status_change_archive", { teamName, supportEmail });
    }

    return fallbackTitle;
};

export const NotificationTeamStatusChange: FC<{ item: any }> = ({ item }) => {
    const { t } = useTranslation();
    const title = useMemo(() => getTeamStatusChangeTitle(item, t), [item, t]);

    if (!title) return null;

    return (
        <SimpleTitle>
            {title}
        </SimpleTitle>
    );
};
